import { render } from "./tesla.vue?vue&type=template&id=2fe64e38"
import script from "./tesla.vue?vue&type=script&lang=js"
export * from "./tesla.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__